import { reducer as getCampaignStatistics } from './getCampaignStatistics'
import { reducer as getCurrentCampaign } from './getCurrentCampaign'
import { reducer as getActiveCampaign } from './getActiveCampaign'
import { reducer as resetCampaignCode } from './resetCampaignCode'
import { reducer as deleteCampaignCode } from './deleteCampaignCode'
import { reducer as resetManyCampaignCodes } from './resetManyCampaignCodes'
import { reducer as deleteManyCampaignCodes } from './deleteManyCampaignCodes'
import { reducer as sendEmailsCampaign } from './sendEmailsCampaign'
import { reducer as closeCurrentCampaign } from './closeCurrentCampaign'
import { reducer as statusCampaign } from './statusCampaign'
import { reducer as statusEmails } from './statusEmails'
import { reducer as createCampaign } from './createCampaign'
import { reducer as getCurrentEmailTemplate } from './getCurrentEmailTemplate'
import { reducer as updateCurrentEmailTemplate } from './updateCurrentEmailTemplate'
import { reducer as pendingCampaign } from './pendingCampaign'
import { reducer as updateTemplateModal } from './updateTemplateModal'
import { reducer as selectedCampaign } from './selectedCampaign'
import { reducer as getCampaignIndividualEmails } from './getCampaignIndividualEmails'
import { reducer as getCampaignBulkEmails } from './getCampaignBulkEmails'
import { reducer as getCampaignActiveId } from './getCampaignActiveId'
import { reducer as getCampaignList } from './getCampaignList'
import { reducer as getCampaignUnassignedEmails } from './getCampaignUnassignedEmails'
import { reducer as campaignAddEmail } from './campaignAddEmail'
import { reducer as getEmailTemplate } from './getEmailTemplate'
import { reducer as getEmailTemplates } from './getEmailTemplates'
import { reducer as createEmailTemplate } from './createEmailTemplate'
import { reducer as selectedEmailTemplate } from './selectedEmailTemplate'
import { reducer as createTemplateModal } from './createTemplateModal'
import { reducer as deleteEmailTemplate } from './deleteEmailTemplate'
import { reducer as updatedEmailTemplate } from './updatedEmailTemplate'
import { reducer as changeCampaignValidity } from './changeCampaignValidity'
import { reducer as getAllCampaignList } from './getAllCampaignList'
import { reducer as getCampaignStatus } from './getCampaignStatus'
import { reducer as setCampaignDisabledFlag } from './setCampaignDisabledFlag'
import { reducer as selectedCodeCampaign } from './selectedCodeCampaign'

export default {
  getCampaignStatistics,
  getCurrentCampaign,
  getActiveCampaign,
  resetCampaignCode,
  deleteCampaignCode,
  resetManyCampaignCodes,
  deleteManyCampaignCodes,
  sendEmailsCampaign,
  closeCurrentCampaign,
  statusCampaign,
  statusEmails,
  createCampaign,
  getCurrentEmailTemplate,
  updateCurrentEmailTemplate,
  pendingCampaign,
  updateTemplateModal,
  selectedCampaign,
  getCampaignIndividualEmails,
  getCampaignBulkEmails,
  getCampaignActiveId,
  getCampaignList,
  getCampaignUnassignedEmails,
  campaignAddEmail,
  getEmailTemplate,
  getEmailTemplates,
  createEmailTemplate,
  selectedEmailTemplate,
  createTemplateModal,
  deleteEmailTemplate,
  updatedEmailTemplate,
  changeCampaignValidity,
  getAllCampaignList,
  getCampaignStatus,
  setCampaignDisabledFlag,
  selectedCodeCampaign
}



// WEBPACK FOOTER //
// ./src/store/campaign/index.js